module.exports = __webpack_public_path__ + "img/JBS.e52f5c27.svg";